import { RTL_LANGUAGES } from './constants';
import { getMultilingualLanguage } from './utils';
import { getQueryParams } from './publicUtils';
export var getSiteLanguage = function (wixCodeApi, isEditor) {
    var multilingualLanguage = getMultilingualLanguage(wixCodeApi.window.multilingual);
    var siteLanguage = wixCodeApi.site.language;
    if (isEditor) {
        var query = getQueryParams();
        var regionalLanguage = query.get('regionalLanguage');
        if (regionalLanguage) {
            siteLanguage = regionalLanguage;
        }
    }
    // NOTE: language can be null (see WEED-18001)
    return multilingualLanguage || siteLanguage || 'en';
};
export var FORM_FACTORS = {
    MOBILE: 'Mobile',
    DESKTOP: 'Desktop',
};
export var isMobile = function (wixCodeApi) {
    return wixCodeApi.window.formFactor === FORM_FACTORS.MOBILE;
};
export var isSSR = function (wixCodeApi) {
    return wixCodeApi.window.rendering.env === 'backend';
};
export var isSEO = function (wixCodeApi) { return wixCodeApi.seo.isInSEO(); };
export var isRTL = function (language) { return RTL_LANGUAGES.includes(language); };
export var EDITORS_ORIGIN = {
    CLASSIC: 'editor',
    EDITOR_X: 'editor_x',
};
// Function to check editor x in iFrame environment
export var isEditorXOrigin = function () {
    var searchParams = new URLSearchParams(window.location.search);
    return searchParams.get('origin') === EDITORS_ORIGIN.EDITOR_X;
};
// Function to check Editor X in viewer Widget and controller environments
// Based on https://wix.slack.com/archives/CAKBA7TDH/p1610466792053500
export var isEditorX = function (styleParams) { var _a; return (_a = styleParams === null || styleParams === void 0 ? void 0 : styleParams.booleans.responsive) !== null && _a !== void 0 ? _a : false; };
// TODO: Rethink solution after there would be better place to check if we are in ADI or not
// https://wix.slack.com/archives/CAKBA7TDH/p1612450595116500
export var isADI = function (queryParams) {
    if (queryParams === void 0) { queryParams = {}; }
    return queryParams.dsOrigin === 'onboarding';
};
export var isClassicEditor = function (queryParams) {
    if (queryParams === void 0) { queryParams = {}; }
    return queryParams.dsOrigin === 'Editor1.4';
};
//# sourceMappingURL=helpers.js.map